interface IconProps {
  className?: string;
}

// PHREATIC brand icon — three stacked groundwater waves. Pure stroke,
// tints via currentColor, stays legible from nav size up to the hero.
export function PhreaticIcon({ className = 'h-6 w-6' }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.6}
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
    >
      <path d="M2 6.6c2.5-2.7 7.5-2.7 10 0s7.5 2.7 10 0" />
      <path d="M2 12c2.5-2.7 7.5-2.7 10 0s7.5 2.7 10 0" />
      <path d="M2 17.4c2.5-2.7 7.5-2.7 10 0s7.5 2.7 10 0" />
    </svg>
  );
}

export default PhreaticIcon;
